import { Spreadsheet, getRangeAddress } from '@syncfusion/ej2-spreadsheet';
import { Uploader } from '@syncfusion/ej2-inputs';
import { ExcelWorksheetCellModel, ExcelWorksheetModel, SetWorkbookDataModel } from '../../Models/Excel/SetWorkbookDataModel';
import { ExcelDataService } from '../../DataService/ExcelDataService';

import { Grid, Filter, Page, Sort, RecordClickEventArgs, Edit, Toolbar, NewRowPosition } from '@syncfusion/ej2-grids';
import { Query, DataManager, WebApiAdaptor } from '@syncfusion/ej2-data';
import { closest } from '@syncfusion/ej2-base';
import { ModalHelper } from '../../Helpers/ModalHelper';
import { Toastr } from '../../Helpers/Toastr';
import { DropDownList, ChangeEventArgs } from '@syncfusion/ej2-dropdowns';

export class CrossReferencesManager {

    constructor(private containerElement: JQuery) { }

    private fileUploadInput : JQuery<HTMLElement>;
    //private workbookContentWrapper : JQuery<HTMLElement>;
    //private viewWorkbookModalHelper : ModalHelper;

    private workbookGrid : Grid;
    

    public initialize() {
        var self = this;

        self.fileUploadInput = self.containerElement.find('#file-upload-container');

        Grid.Inject(Edit, Toolbar, Filter, Page, Sort);

        self.initializeUploadAndWorkbooksTable();
    }

    private initializeUploadAndWorkbooksTable() {
        var self = this;

        var loadingContainer = self.containerElement.find('#loading-container');
        var uploadContainer = self.containerElement.find('#upload-and-workbooks-container');
        var gridElement : JQuery<HTMLElement> = self.containerElement.find('#Grid');
        var gridContentElement : JQuery<HTMLElement> = gridElement;

        var uploadObject : Uploader;
        

        // var uploadedDocumentId = '';

        // var spreadsheetElement = self.containerElement.find('#element');
    

        // uploadObject = new Uploader({
        //     maxFileSize: 40000000,
        //     autoUpload: false,
        //     asyncSettings: {
        //         saveUrl: '/api/company/commontables/uploadimpaxlsx',
        //         removeUrl: '/api/company/commontables/removefile'
        //     },
        //     multiple: false,
        //     allowedExtensions: '.xlsx',
        //     created: () => {
        //         loadingContainer.addClass('d-none');
        //         uploadContainer.removeClass('d-none');
        //     },
        //     beforeUpload: () => {
        //         spreadsheetElement.addClass('d-none');
        //         //spreadsheet.destroy();
        //     },
        //     uploading: () => {
        //         //self.workbookContentWrapper.css('height', '78dvh');
        //     },
        //     success: (args: any) => {                    
        //         if (args.operation == 'upload') {
        //             uploadedDocumentId = args.e.target.response;
        //             //spreadsheet.open({ file: args.file.rawFile });
        //         }
        //     },
        // });



        // render initialized Uploader
        // uploadObject.appendTo('#file-upload-input');
        // self.fileUploadInput.removeClass('d-none');

        let data: DataManager = new DataManager({
            url: '/api/company/lookup/crossreferences',
            adaptor: new WebApiAdaptor
        });

        let newRowPosition: { [key: string]: Object }[] = [
            { id: 'Top', newRowPosition: 'Top' },
            { id: 'Bottom', newRowPosition: 'Bottom' }
        ];

        self.workbookGrid = new Grid(
            {
                height: '100%',
                dataSource: data,
                editSettings: { allowEditing: true, allowAdding: true, allowDeleting: true, mode: 'Normal', showDeleteConfirmDialog: true, newRowPosition: 'Top' },
                columns: [
                    { field: 'ConversionField', headerText: 'Type', width: 150, editType: 'dropdownedit', edit: { params: { popupHeight: '300px' } }, validationRules: { required: true } },
                    { field: 'DataSource', headerText: 'Data source', width: 170, editType: 'dropdownedit', edit: { params: { popupHeight: '300px' } }, validationRules: { required: true }},
                    { field: 'Description', headerText: 'Text in', autoFit: true, validationRules: { required: true }},
                    { field: 'TextOut', headerText: 'Text out', autoFit: true},
                ],
                allowSorting: true,
                allowPaging: true,
                allowFiltering: false,
                allowSelection: true,
                pageSettings: { pageSize: 100 },
                toolbar: ['Add', 'Update', 'Cancel'],
                actionComplete: actionComplete,
                created: () => {
                    gridContentElement = gridContentElement.find('.e-content')

                    loadingContainer.addClass('d-none');
                    uploadContainer.removeClass('d-none');
                },
            });

        self.workbookGrid.appendTo('#Grid');

        let dropDownType: DropDownList = new DropDownList({
            dataSource: newRowPosition,
            fields: { text: 'newRowPosition', value: 'id' },
            value: 'Top',
            change: (e: ChangeEventArgs) => {
                let newRowPosition: string = <string>e.value;
                self.workbookGrid.editSettings.newRowPosition = <NewRowPosition>newRowPosition;
                self.workbookGrid.refresh();
            }
        });
        dropDownType.appendTo('#newRowPosition');

        function actionComplete(args) {
            if ((args.requestType == 'save')) {
                args.promise.then((result) => {
                    if(result.isSuccessStatusCode == false) {
                        Toastr.Error("Error when adding cross reference", args.reasonPhrase);
                    }
                })
            }
          }
    }
    

}